/* eslint-disable import/prefer-default-export */

// Simple notification service to show snackbars from anywhere in the app
class NotificationService {
  constructor() {
    this.subscribers = [];
  }

  subscribe(callback) {
    this.subscribers.push(callback);
    return () => {
      this.subscribers = this.subscribers.filter((sub) => sub !== callback);
    };
  }

  showError(message) {
    this.notify({
      message,
      severity: 'error',
      duration: 6000,
    });
  }

  showSuccess(message) {
    this.notify({
      message,
      severity: 'success',
      duration: 4000,
    });
  }

  showInfo(message) {
    this.notify({
      message,
      severity: 'info',
      duration: 4000,
    });
  }

  showWarning(message) {
    this.notify({
      message,
      severity: 'warning',
      duration: 5000,
    });
  }

  notify(notification) {
    this.subscribers.forEach((callback) => callback(notification));
  }
}

export const notificationService = new NotificationService();
